import React, { useRef } from "react";
import { FONT_SIZES } from "../../styles";
import { useWindowDimensions, useIsVisible, useMediaQuery } from "../../utils";
import "./experience.css";

const sections = [
  {
    title: "Web Engineer @ Google",
    details: [
      "Architected AI-powered platforms for Google's 45K+ person Global Business Organization, aligning product and sales on technical strategy to reduce operational overhead",
      "Stack: Angular, TypeScript, Python, Java, SQL, gRPC, Protobuf",
    ],
  },
  {
    title: "Mobile Web Engineer @ Google",
    details: [
      "Partnered with Fortune 500 advertisers to improve conversions through mobile web performance via technical audits, C-suite consultations, and custom tooling",
      "Stack: JavaScript/TypeScript, HTML, CSS",
    ],
  },
  {
    title: "Software Engineer II @ Cvent",
    details: [
      "Developed production React Native features for Attendee Hub and On-site Exhibitor apps",
      "Stack: React Native, Couchbase Server",
    ],
  },
  {
    title: "Software Engineer @ Red Foundry",
    details: [
      "Engineered, deployed, and maintained full-stack mobile and web applications",
      "Stack: React Native, React, TypeScript, Node.js, Redux and AWS",
    ],
  },
  {
    title: "Database Admin @ Optime Realty",
    details: [
      "Managed CRM workflows, built internal web applications, and automated manual administrative work",
      "Stack: Python, PHP, JavaScript, Node.js",
    ],
  },
  {
    title: "Tech education",
    details: [
      "Fullstack Academy Web Development Diploma",
      <>
        {"Harvard's CS50x: Introduction to Computer Science "}
        <a
          href="https://cs50.harvard.edu/certificates/c48e06fe-8708-4add-aaeb-8f9d985647b7"
          target="_blank"
          rel="noreferrer"
        >
          Certificate
        </a>
      </>,
      <>
        {"Harvard's CS50p: Introduction to Programming with Python "}
        <a
          href="https://cs50.harvard.edu/certificates/9a831fae-5cbf-49f6-a41a-260c67f88c66"
          target="_blank"
          rel="noreferrer"
        >
          Certificate
        </a>
      </>,
    ],
  },
  {
    title: "Music background",
    details: [
      "Bachelor of Music Performance in Classical Guitar",
      "Curated radio station airplay @ 93XRT & taught K-12 guitar",
    ],
  },
];

const Experience = () => {
  return (
    <div className="experience-container">
      {sections.map((section, i) => (
        <div
          key={`experience-${i}`}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <ExperienceTitle title={section.title} />
          {section.details?.map((detail, j) => (
            <ExperienceDetail key={`${i}-${j}`} detail={detail} />
          ))}
          <div style={{ ...(i < sections.length - 1 && { height: "2vh" }) }} />
        </div>
      ))}
    </div>
  );
};

const ExperienceTitle = ({ title }) => {
  const isMobile = useMediaQuery();
  const domRef = useRef(null);
  const isVisible = useIsVisible(domRef);
  const { height: screenHeight } = useWindowDimensions();

  const calcStyle = () => ({
    height: 0.08 * screenHeight,
    minHeight: FONT_SIZES.xxxl,
    top: Math.max(90, 0.18 * screenHeight),
    ...(isMobile && {
      top: Math.max(90, 0.12 * screenHeight),
      fontSize: FONT_SIZES.s,
      height: 0.08 * screenHeight,
      minHeight: `calc(3 * ${FONT_SIZES.m})`,
    }),
  });

  return (
    <div
      className={`experience-title fade-in-section ${
        isVisible ? "is-visible" : ""
      }`}
      style={calcStyle()}
      ref={domRef}
    >
      {title}
    </div>
  );
};

const ExperienceDetail = ({ detail }) => {
  const isMobile = useMediaQuery();
  const domRef = useRef(null);
  const isVisible = useIsVisible(domRef);
  return (
    <div
      className={`experience-detail fade-in-section ${
        isVisible ? "is-visible" : ""
      }`}
      style={{
        fontSize: isMobile ? FONT_SIZES.xs : FONT_SIZES.s,
      }}
      ref={domRef}
    >
      {"//"} {detail}
      <div style={{ height: "1vh" }} />
    </div>
  );
};

export default Experience;
